import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

import Select from '../../../Select';
import TicketType from '../TicketType';
import type { ITicketType } from '../TicketType';
import { TYPES } from '../TicketType';

import { Open as OpenIcon } from '@icons/tagsselect';

const { StyledOption, StyledStatusIcon } = Select;

interface ISelect {
  className?: string;
  disabled?: boolean;
  onChange?: (value: any) => void;
  onToggle?: () => void;
  options: Array<{ title: string; value: string }>;
  placeholder?: string | null;
  size?: number;
  value?: string;
}

interface TicketTypeSelectorProps extends ISelect {
  options: Array<{ title: string; value: string } & ITicketType>;
}

interface TicketTypeSelectorState {
  isOpen: boolean;
}

class TicketTypeSelector extends React.PureComponent<
  TicketTypeSelectorProps,
  TicketTypeSelectorState
> {
  static headRenderer(isOpen) {
    return (
      { subtype, type } = { subtype: TYPES.UNKNOWN, type: TYPES.UNKNOWN }
    ) => (
      <StyledHeader>
        <StyledTicketType subtype={subtype} type={type} />
        <StyledOpenIcon open={isOpen} />
      </StyledHeader>
    );
  }

  static optionRenderer(
    { subtype, type } = { subtype: TYPES.UNKNOWN, type: TYPES.UNKNOWN }
  ) {
    return <TicketType subtype={subtype} type={type} />;
  }

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleChange({ detail }) {
    const { value } = detail;
    const { onChange } = this.props;
    onChange?.(value);
  }

  handleToggle(isOpen) {
    this.setState({
      isOpen,
    });
  }

  render() {
    const { isOpen } = this.state;
    const { value, options } = this.props;

    return (
      <StyledTicketTypeSelector
        {...this.props}
        value={value}
        options={options}
        headRenderer={TicketTypeSelector.headRenderer(isOpen)}
        onChange={this.handleChange}
        onToggle={this.handleToggle}
        optionRenderer={TicketTypeSelector.optionRenderer}
      />
    );
  }
}

const StyledTicketTypeSelector = styled(Select)`
  background-color: transparent;
  height: 23px;
  width: 100%;
  position: relative;

  > button {
    padding: 0;
  }

  ${StyledStatusIcon} {
    display: none;
  }

  ${StyledOption} {
    align-items: center;
    color: inherit !important;
    display: flex;
    height: 45px;
  }
`;

const StyledHeader = styled.div`
  align-items: center;
  display: flex;
  height: 23px;
  width: 100%;
  position: relative;
`;

const StyledTicketType = styled(TicketType)`
  padding-right: 30px;
`;

const StyledOpenIcon = styled(OpenIcon)<{ open: boolean }>`
  height: auto;
  position: absolute;
  right: 10px;
  width: 10px;

  ${({ open }) =>
    open &&
    `
    transform: rotate(180deg);
  `}
`;

export default TicketTypeSelector;
